import React from "react";
import Spinner from "../../../components/presentationals/Spinner";
import Error from "../../../components/Error";

const TableName = (props) => {
  const { operationalDashObj } = props;
  return (
    <div
      className="whitebox wow fadeInUp"
      data-wow-delay=".6s"
      data-wow-duration="0.7s"
    >
      <div className="tab-content">
        <div className="tab-pane fade in active">
          <div className="tabcontbox">
            {
              //if loading is true and teher is no error means waiting for data to come so show spinner
              operationalDashObj?.loading && !operationalDashObj.error ? (
                <Spinner />
              ) : //else if laoding is now false but an error is there then show error
              !operationalDashObj?.loading && operationalDashObj.error ? (
                <Error error={operationalDashObj.error} />
              ) : (
                //else if loading is not true and error also is not true, means there is response
                <div
                  className="datatable "
                  data-cy="earnings-table"
                  style={{ overflowX: "auto" }}
                >
                  <table className="table table-striped">
                    <thead>
                      <tr role="row">
                        <th
                          style={{
                            whiteSpace: "nowrap",
                            padding: "10px 20px",
                            fontWeight: "bold",
                          }}
                        >
                          Trans Date
                        </th>
                        <th
                          style={{
                            whiteSpace: "nowrap",
                            padding: "10px 20px",
                            fontWeight: "bold",
                          }}
                        >
                          Table Name
                        </th>
                        <th
                          style={{
                            whiteSpace: "nowrap",
                            padding: "10px 20px",
                            fontWeight: "bold",
                          }}
                        >
                          Status
                        </th>
                        <th
                          style={{
                            whiteSpace: "nowrap",
                            padding: "10px 20px",
                            fontWeight: "bold",
                          }}
                        >
                          Start Time
                        </th>
                        <th
                          style={{
                            whiteSpace: "nowrap",
                            padding: "10px 20px",
                            fontWeight: "bold",
                          }}
                        >
                          End Time
                        </th>
                        <th
                          style={{
                            whiteSpace: "nowrap",
                            padding: "10px 20px",
                            fontWeight: "bold",
                          }}
                        >
                          Data Processed
                        </th>
                        <th
                          style={{
                            whiteSpace: "nowrap",
                            padding: "10px 20px",
                            fontWeight: "bold",
                          }}
                        >
                          Number Of Records
                        </th>
                        <th
                          style={{
                            whiteSpace: "nowrap",
                            padding: "10px 20px",
                            fontWeight: "bold",
                          }}
                        >
                          Error Occurred
                        </th>
                        <th
                          style={{
                            whiteSpace: "nowrap",
                            padding: "10px 20px",
                            fontWeight: "bold",
                          }}
                        >
                          Error Message
                        </th>
                        <th
                          style={{
                            whiteSpace: "nowrap",
                            padding: "10px 20px",
                            fontWeight: "bold",
                          }}
                        >
                          Load Seq
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        //if data is present, show data
                        operationalDashObj?.data?.content?.length ? (
                          operationalDashObj.data.content.map((obj, index) => {
                            return (
                              <tr key={index}>
                                <td
                                  style={{
                                    whiteSpace: "nowrap",
                                    padding: "10px 20px",
                                  }}
                                >
                                  {obj.lmTransDate}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "nowrap",
                                    padding: "10px 20px",
                                  }}
                                >
                                  {obj.lmTableName}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "nowrap",
                                    padding: "10px 20px",
                                  }}
                                >
                                  {obj.lmStatus}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "nowrap",
                                    padding: "10px 20px",
                                  }}
                                >
                                  {obj.lmStartTime}
                                </td>

                                <td
                                  style={{
                                    whiteSpace: "nowrap",
                                    padding: "10px 20px",
                                  }}
                                >
                                  {obj.lmEndTime}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "nowrap",
                                    padding: "10px 20px",
                                    textAlign: "center",
                                  }}
                                >
                                  {obj.lmDataProcessed}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "nowrap",
                                    padding: "10px 20px",
                                  }}
                                >
                                  {obj.lmNumberOfRecords}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "nowrap",
                                    padding: "10px 20px",
                                  }}
                                  >
                                  {obj.lmErrorMessage}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "nowrap",
                                    padding: "10px 20px",
                                    textAlign: "center"
                                  }}
                                >
                                  {obj.lmErrorOccured}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "nowrap",
                                    padding: "10px 20px",
                                  }}
                                >
                                  {obj.lmLoadSeq}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          //if the response is empty, show no data available
                          <tr>
                            <td colSpan={12}>No Data Available</td>
                          </tr>
                        )
                      }
                    </tbody>
                  </table>
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableName;
